import { PremiumStoreApiClient } from '@wix/premium-fed-sdk/@api-clients-react';
import { cyclePriceDisplayPropsFromProductPricing } from '../utils';
export const queryCyclePricingDisplayProps = async _ref => {
  var _dynamicOffering$prod, _productInfo$pricingI, _productInfo$pricingI2;
  let {
    httpClient,
    request
  } = _ref;
  const {
    maximalMonthlyPrice,
    msid,
    productTypeId,
    productId,
    interval,
    quantity
  } = request;
  const dynamicOffering = await PremiumStoreApiClient.query.getUserOffering({
    httpClient,
    request: {
      productTypeId,
      msid
    }
  });
  const productInfo = (_dynamicOffering$prod = dynamicOffering.products) == null ? void 0 : _dynamicOffering$prod.find(product => product.productId === productId);
  if (!productInfo) {
    throw new Error(`productId: ${productId} not found`);
  }
  const displayProps = cyclePriceDisplayPropsFromProductPricing({
    interval,
    catalogPricing: ((_productInfo$pricingI = productInfo.pricingInfo) == null ? void 0 : _productInfo$pricingI.catalogPricing) ?? [],
    salePricing: (_productInfo$pricingI2 = productInfo.pricingInfo) == null || (_productInfo$pricingI2 = _productInfo$pricingI2.salePricing) == null ? void 0 : _productInfo$pricingI2.discountPrices,
    currencySettings: dynamicOffering.currencySettings ?? {},
    maximalMonthlyPrice,
    quantity
  });
  return {
    displayProps
  };
};
//# sourceMappingURL=queryCyclePricingDisplayProps.js.map